









































import { Col, Row, Swipe, SwipeItem } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
import moreList from "@/components/multiple/moreList.vue";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    moreList,
    "van-row": Row,
    "van-col": Col
  }
})
export default class NewsMultiple extends Vue {
  @Prop()
  private imgList: any;
  @Prop()
  private imgInfo: any;
  @Prop()
  private indexPage: any; // 当前页面的index
  @Prop()
  private imgMoreList: any; // 推荐新闻
  @Prop()
  private showMore: any; // 是否显示推荐新闻
  private current: string = "";
  private vfrom: string = "";
  mounted() {
    console.log("xxxx" + this.indexPage);
    this.current = this.indexPage;
    console.log(this.imgMoreList);
    this.vfrom = (this.$route.query.vfrom as string) || "";
  }
  onChange(index: string) {
    this.current = index;
    console.log(this.current);
    // 存当前的index 把值传给父组件
    this.$emit("getCurrentIndexV", this.current);
  }
  next() {
    let refswipe: any = this.$refs.swiper;
    refswipe.next();
  }
  prev() {
    let refswipe: any = this.$refs.swiper;
    refswipe.prev();
  }
}
